import EmployeesChart from "components/charts/modern/EmployeesChart";
import {
  CompanyContainer,
  CompanyContentContainer,
  CompanyTabsContent,
  CompanyTabsList,
} from "components/company/v3/CompanyContainers";
import TotalCompensationsContent from "components/company/v3/contents/TotalCompensationsContent";
import { CompanyGovernanceTabEnum } from "components/company/v3/menu/enums";
import classNames from "components/ui/classNames";
import { Tabs } from "components/ui/Tabs";
import useSelfie from "lib/hooks/useSelfie";
import { BriefcaseBusinessIcon, DollarSignIcon } from "lucide-react";
import { useIntl } from "react-intl";

interface AmericanGovernanceBoxProps {
  tickerSymbol: string;
  tab: CompanyGovernanceTabEnum;
  onChangeTab: (tab: CompanyGovernanceTabEnum) => void;
}

export default function AmericanGovernanceBox({ tickerSymbol, tab, onChangeTab }: AmericanGovernanceBoxProps) {
  const intl = useIntl();
  const viewer = useSelfie();
  if (!viewer?.isPremium) {
    return null;
  }

  return (
    <CompanyContainer
      className={classNames({
        "xl:h-full": [CompanyGovernanceTabEnum.COMPENSATION].includes(tab),
      })}
    >
      <CompanyContentContainer>
        <Tabs
          defaultValue={CompanyGovernanceTabEnum.COMPENSATION}
          value={tab}
          onValueChange={(value) => onChangeTab(value as CompanyGovernanceTabEnum)}
          className="h-full w-full"
        >
          <CompanyTabsList
            tabs={[
              {
                value: CompanyGovernanceTabEnum.COMPENSATION,
                label: intl.formatMessage({
                  defaultMessage: "Remuneração",
                  description: "Aba do menu superior da empresa",
                  id: "mD4xGc",
                }),
                icon: <DollarSignIcon className="inline-flex" size={16} strokeWidth={2} />,
              },
              {
                value: CompanyGovernanceTabEnum.EMPLOYEES,
                label: intl.formatMessage({
                  defaultMessage: "Empregados",
                  description: "Aba do menu superior da empresa",
                  id: "YuiKZP",
                }),
                icon: <BriefcaseBusinessIcon className="inline-flex" size={16} strokeWidth={2} />,
              },
            ]}
          />

          <CompanyTabsContent value={CompanyGovernanceTabEnum.COMPENSATION}>
            <TotalCompensationsContent />
          </CompanyTabsContent>

          <CompanyTabsContent value={CompanyGovernanceTabEnum.EMPLOYEES}>
            <EmployeesChart tickerSymbols={[tickerSymbol]} />
          </CompanyTabsContent>
        </Tabs>
      </CompanyContentContainer>
    </CompanyContainer>
  );
}
